import { pxToRem, stringLiteralsArray } from '../../../../utils';
import { pickValuesFromColorScheme } from '../../../colorUtils';
export var iconColorAreas = stringLiteralsArray('foreground');
export var svgIconVariables = function svgIconVariables(siteVars) {
  return {
    colorScheme: pickValuesFromColorScheme(siteVars.colorScheme, iconColorAreas),
    color: undefined,
    borderColor: undefined,
    backgroundColor: undefined,
    brandColor: siteVars.brandColor,
    secondaryColor: siteVars.colors.white,
    redColor: siteVars.colors.red[400],
    disabledColor: siteVars.colors.grey[250],
    smallestSize: pxToRem(7),
    smallerSize: pxToRem(10),
    smallSize: pxToRem(12),
    mediumSize: pxToRem(16),
    largeSize: pxToRem(20),
    largerSize: pxToRem(32),
    largestSize: pxToRem(40),
    horizontalSpace: pxToRem(10)
  };
};